import { createStore, applyMiddleware, compose, combineReducers, Store, ReducersMapObject, Reducer } from "redux";
import thunk from "redux-thunk";
import { History } from "history";
import { routerReducer, routerMiddleware } from "react-router-redux";
import * as StoreModule from "./store";

export function configureStore(history: History, initialState?: StoreModule.IApplicationState) {
    // Build middleware. These are functions that can process the actions before they reach the store.
    const windowIfDefined = typeof window === "undefined" ? null : window as any;

    // If devTools is installed, connect to it
    const composeEnhancers = windowIfDefined.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

    const createStoreWithMiddleware = (reducer: Reducer<StoreModule.IApplicationState>) => createStore(reducer, /* preloadedState, */ composeEnhancers(
        applyMiddleware(thunk, routerMiddleware(history))
    ));

    // Combine all reducers and instantiate the app-wide store instance
    const allReducers = buildRootReducer(StoreModule.Reducers);

    //const store = createStoreWithMiddleware(allReducers, (initialState) as any) as Store<StoreModule.IApplicationState>;
    const store = createStoreWithMiddleware(allReducers) as Store<StoreModule.IApplicationState>;

    // Enable Webpack hot module replacement for reducers
    if (module.hot) {
        module.hot.accept("./store", () => {
            const nextRootReducer = require<typeof StoreModule>("./store");
            store.replaceReducer(buildRootReducer(nextRootReducer.Reducers));
        });
    }

    return store;
}

function buildRootReducer(allReducers: ReducersMapObject) {
    return combineReducers<StoreModule.IApplicationState>(Object.assign({}, allReducers, { routing: routerReducer }));
}